<template>
    <span
        :class="['inline-flex shrink-0 items-center justify-center rounded-full text-white', backgroundClass, glyphClass]"
        :style="{ width: size + 'px', height: size + 'px' }"
        :aria-label="ariaLabel"
        role="img"
    >
        <Check v-if="status === 'approved'" class="h-[55%] w-[55%]" />
        <Bang v-else-if="status === 'pending'" class="h-[55%] w-[55%]" />
        <Warning v-else-if="status === 'unscheduled'" class="h-[55%] w-[55%]" />
        <Wrench v-else-if="status === 'inoperable'" class="h-[55%] w-[55%]" />
        <Hourglass v-else class="h-[55%] w-[55%]" />
    </span>
</template>

<script setup>
import { computed } from 'vue';
import { trans } from '@/mixins/i18n';
import Check from '@/../icons/Check.vue';
import Bang from '@/../icons/Bang.vue';
import Hourglass from '@/../icons/Hourglass.vue';
import Warning from '@/../icons/Warning.vue';
import Wrench from '@/../icons/Wrench.vue';

const props = defineProps({
    status: {
        type: String,
        required: true,
        validator: (v) => ['unscheduled', 'untested', 'pending', 'approved', 'inoperable'].includes(v),
    },
    size: {
        type: Number,
        default: 20,
    },
});

const backgroundClass = computed(
    () =>
        ({
            approved: 'bg-compliance-approved',
            pending: 'bg-compliance-pending',
            unscheduled: 'bg-compliance-unscheduled',
            untested: 'bg-compliance-untested',
            inoperable: 'bg-compliance-inoperable',
        })[props.status],
);

const glyphClass = computed(() => (props.status === 'untested' || props.status === 'unscheduled' ? 'text-compliance-untested-fg' : ''));

const ariaLabel = computed(() => trans(`dashboard.v2.testing_compliance.status.${props.status}`));
</script>
